// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"aa57f421","184":"6d27367f","342":"ccc48b59","365":"d5e7101d","560":"21f71be3","591":"17c42636","678":"da0bc83e","735":"1fb98876","953":"1968fef2"}[chunkId] + ".chunk.js";
};